import React from "react";
import { assetCategories } from "_constants";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormFooter from "forms/components/FormFooter";
import FormRow from "forms/components/FormRow";
import { DropdownField, RenderField } from "forms/fields";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import assetLeadName from "utils/assetLeads/name";
import Translate from "utils/translate";

import formStyles from "forms/forms.css";

const { t } = new Translate("AssetLeadCreateForm");

const sortCategories = (a, b) => t(`assetCategories.${a}`).localeCompare(t(`assetCategories.${b}`));

const AssetLeadCreateForm = ({ handleSubmit, isSubmitting, portfolios, values }) => (
  <form className={formStyles.form} onSubmit={handleSubmit}>
    <FormContainer title={t("asset.address")}>
      <FormRow columns={2}>
        <Field component={RenderField} label={t("address")} name="address" />
        <Field component={RenderField} label={t("asset.city")} name="city" />
      </FormRow>
    </FormContainer>
    <FormContainer title={t("assetLead")}>
      <FormRow columns={2}>
        <Field
          component={RenderField}
          label={t("name")}
          name="name"
          placeholder={assetLeadName(values)}
        />
        <Field
          component={DropdownField}
          label={t("category")}
          name="category"
          valueExtractor={(c) => t(`assetCategories.${c}`)}
          values={assetCategories.sort(sortCategories)}
        />
      </FormRow>
    </FormContainer>
    <FormContainer title={t("portfolio")}>
      <FormRow columns={2}>
        <Field
          component={DropdownField}
          label={t("portfolio")}
          name="portfolio"
          valueExtractor={(p) => p.name}
          values={portfolios}
        />
      </FormRow>
    </FormContainer>
    <FormFooter>
      <SubmitButton
        isSubmitting={isSubmitting}
        submitLabel={t("add")}
        submittingLabel={t("adding")}
      />
    </FormFooter>
  </form>
);

AssetLeadCreateForm.propTypes = {
  values: PropTypes.shape({
    country: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  values: PropTypes.object, // eslint-disable-line
};

export default AssetLeadCreateForm;
